import { createContext } from "react";
import { IRCAAPComplianceContext } from "./RCAAPComplianceContextInterfaces";
import {
    RCAAPComplianceByResponsibleFilterEnum,
    RCAAPComplianceRangeEnum,
} from "pages/Corporate/RCA/RCAAPCompliance/RCAAPComplianceInterfaces";
import { ComplianceTypes } from "constants/constants";

export const initialState: IRCAAPComplianceContext = {
    filters: {
        periodOption: RCAAPComplianceRangeEnum.thirty as unknown as number,
        typeOption: RCAAPComplianceByResponsibleFilterEnum["a_to_z_asc"],
        complianceType: ComplianceTypes.NONE,
        meetingTypeIds: [],
        totalMeetingTypes: 0,
    },
    handleSetFilters: () => {},
    handleSetTypeFilter: () => {},
    handleSetComplianceType: () => {},
    handleSetMeetingTypes: () => {},
    handleRemoveDefaultFilters: async () => {},
    handleSetFiltersDefault: async () => {},
    userFiltersDefault: null,
    loadingDefaultOperations: false,
    isFiltersDefault: false,
};

export const RCAAPComplianceContext = createContext(initialState);
